"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Draw;

var _Draw = require("@adobe/react-spectrum-workflow/dist/Draw");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Draw(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Draw.A4uDraw, null));
}